import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import {root} from '../../../../routes/root';

const router = createBrowserRouter(root);

/** Should be placed inside the store provider */
const AppRouter = () => {
  return (
    <RouterProvider router={router}/>
  );
};

export default AppRouter;
